import { useNavigate } from 'react-router-dom';
import { ReactElement, useContext } from 'react';
import { CategoriesContext } from '../App';
import { Category, Product } from '../types/catalog';
import { useNewProducts } from '../util/use-category-products';

export interface CategoryOuterRenderProps {
    currentCategory: Category | null;
    goBack: () => void;
    products: Product[];
}

function CategoryOuter({ render }: { render: (props: CategoryOuterRenderProps) => ReactElement | null }) {
    const { currentCategory } = useContext(CategoriesContext);
    const navigate = useNavigate();
    const products = useNewProducts(currentCategory);
    const Component = render;
    return <Component currentCategory={currentCategory} goBack={() => navigate(-1)} products={products} />;
}

export default CategoryOuter;
